import React, { useEffect, useState, useRef } from 'react';
import { collection, onSnapshot, doc, setDoc, deleteDoc, query, where, getDocs } from 'firebase/firestore';
import { firestore } from './../../FirebaseUtils';
import { Table, Button } from 'react-bootstrap';
import ArrowUp from '../symbol/ArrowUp';
import ArrowDown from '../symbol/ArrowDown';

function AdminUsersAnswersAll() {
    const [ loading, setLoading ] = useState(true);
    const [ errorMessage, setErrorMessage ] = useState();

    const [ answerDocs, setAnswerDocs ] = useState([]);
    const [ employees, setEmployees ] = useState([]);

    const sortByDateAsc = (elem1, elem2) => {
        if (!elem1.timestamp || !elem2.timestamp) return 0;
        return elem1.timestamp.localeCompare(elem2.timestamp);
    }

    const sortByDateDesc = (elem1, elem2) => {
        if (!elem1.timestamp || !elem2.timestamp) return 0;
        return elem2.timestamp.localeCompare(elem1.timestamp);
    }

    const sortByEmployeeIdAsc = (elem1, elem2) => {
        if (!elem1.employeeId || !elem2.employeeId) return 0;
        return elem1.employeeId.localeCompare(elem2.employeeId);
    }

    const sortByEmployeeIdDesc = (elem1, elem2) => {
        if (!elem1.employeeId || !elem2.employeeId) return 0;
        return elem2.employeeId.localeCompare(elem1.employeeId);
    }

    const sortByEmployeeNameAsc = (elem1, elem2) => {
        if (!elem1.name || !elem2.name) return 0;
        return elem1.name.localeCompare(elem2.name);
    }

    const sortByEmployeeNameDesc = (elem1, elem2) => {
        if (!elem1.name || !elem2.name) return 0;
        return elem2.name.localeCompare(elem1.name);
    }

    const sortByEmployeeSurnameAsc = (elem1, elem2) => {
        if (!elem1.surname || !elem2.surname) return 0;
        return elem1.surname.localeCompare(elem2.surname);
    }

    const sortByEmployeeSurnameDesc = (elem1, elem2) => {
        if (!elem1.surname || !elem2.surname) return 0;
        return elem2.surname.localeCompare(elem1.surname);
    }

    const sortByEmployeeEmailAsc = (elem1, elem2) => {
        if (!elem1.email || !elem2.email) return 0;
        return elem1.email.localeCompare(elem2.email);
    }

    const sortByEmployeeEmailDesc = (elem1, elem2) => {
        if (!elem1.email || !elem2.email) return 0;
        return elem2.email.localeCompare(elem1.email);
    }

    const sortByScoreAsc = (elem1, elem2) => {
        //if (!elem1.score || !elem2.score) return 0; // Don't do this, otherwise when score is 0, it will not sort properly!
        if (elem1.score === undefined || elem2.score === undefined) return 0;
        return elem1.score - elem2.score;
    }

    const sortByScoreDesc = (elem1, elem2) => {
        //if (!elem1.score || !elem2.score) return 0; // Don't do this, otherwise when score is 0, it will not sort properly!
        if (elem1.score === undefined || elem2.score === undefined) return 0;
        return elem2.score - elem1.score;
    }

    const [ sortBy, setSortBy ] = useState("sortByDateDesc");
    const [ sortFunc, setSortFunc ] = useState(() => sortByDateDesc);

    useEffect(() => {


        load();

        // // Get a reference to the "questions" collection
        // const docsRef = collection(firestore, 'usersAnswers');

        // const docsRef2 = collection(firestore, 'employees');
        // const unsubscribe2 = onSnapshot(docsRef2, async (snapshot) => {
        //     setErrorMessage("");
        //     setLoading(true);
    
        //     var employees = snapshot.docs.map((doc) => ({
        //         id: doc.id,
        //         ...doc.data()
        //     }));

        //     setEmployees(employees);

        //     setLoading(false);
        // });

        // // Listen for changes in the collection
        // const unsubscribe = onSnapshot(docsRef, async (snapshot) => {
        //     setErrorMessage("");
        //     setLoading(true);
    
        //     const answers = snapshot.docs.map((doc) => {
        //         const employee = employees.find((el) => el.id === doc.data().employeeId);

        //         console.log('employee', employee)

        //         return ({
        //             id: doc.id,
        //             name: employee.name,
        //             surname: employee.surname,
        //             email: employee.email,
        //             ...doc.data()
        //         }
        //     )});

        //     setAnswerDocs(answers);

        //     setLoading(false);

        // });

        // Clean up the listener on unmount
        return () => {
            // unsubscribe();
            // unsubscribe2();
        }

    }, []);

    async function load() {
        setLoading(true);

        const employeesData = await loadEmployees();
        await loadAnswers(employeesData);

        setLoading(false);
    }

    async function loadEmployees() {
        const employeesRef = collection(firestore, 'employees');

        const querySnapshot = await getDocs(employeesRef);
        const employeesData = querySnapshot.docs.map((doc) => ({
            id: doc.id,
            ...doc.data(),
        }));
        setEmployees(employeesData);

        return employeesData;
    }

    async function loadAnswers(employeesData) {
        const docsRef = collection(firestore, 'usersAnswers');

        const querySnapshot = await getDocs(docsRef);
        const usersAnswersData = querySnapshot.docs.map((doc) => {
            const employee = employeesData.find((el) => el.id === doc.data().employeeId);

            return ({
                id: doc.id,
                name: employee ? employee.name : '',
                surname: employee ? employee.surname : '',
                ...doc.data(),
            })
        });
        setAnswerDocs(usersAnswersData);

        // await getDocs(docsRef, (snapshot) => {
        //     const answers = snapshot.docs.map((doc) => {
        //         const employee = employeesResult.find((el) => el.id === doc.data().employeeId);

        //         console.log('employee', employee)

        //         return ({
        //             id: doc.id,
        //             name: employee.name,
        //             surname: employee.surname,
        //             email: employee.email,
        //             ...doc.data()
        //         }
        //     )});

        //     setAnswerDocs(answers);
        // });
    }

    function formatDate(data) {
        return `${('0'+data.date).slice(-2)}-${('0'+data.month).slice(-2)}-${data.year} ${('0'+data.hour).slice(-2)}:${('0'+data.month).slice(-2)}:${('0'+data.second).slice(-2)}`;
    }

    function getEmployeeField(id, field) {
        if (employees) {
            const em = employees.find((el) => el.id === id);
            return em[field];
        }

        return null;
    }

    function onClickSortByDate(e) {
        console.log(sortBy);

        if (sortBy === "sortByDateAsc") {
            setSortBy("sortByDateDesc");
            setSortFunc(() => sortByDateDesc);
        }
        else {
            setSortBy("sortByDateAsc");
            setSortFunc(() => sortByDateAsc);
        }
    }

    function onClickSortByEmployeeId(e) {
        if (sortBy === "sortByEmployeeIdAsc") {
            setSortBy("sortByEmployeeIdDesc");
            setSortFunc(() => sortByEmployeeIdDesc);
        }
        else {
            setSortBy("sortByEmployeeIdAsc");
            setSortFunc(() => sortByEmployeeIdAsc);
        }
    }

    function onClickSortByEmployeeName(e) {
        if (sortBy === "sortByEmployeeNameAsc") {
            setSortBy("sortByEmployeeNameDesc");
            setSortFunc(() => sortByEmployeeNameDesc);
        }
        else {
            setSortBy("sortByEmployeeNameAsc");
            setSortFunc(() => sortByEmployeeNameAsc);
        }
    }

    function onClickSortByEmployeeSurname(e) {
        if (sortBy === "sortByEmployeeSurnameAsc") {
            setSortBy("sortByEmployeeSurnameDesc");
            setSortFunc(() => sortByEmployeeSurnameDesc);
        }
        else {
            setSortBy("sortByEmployeeSurnameAsc");
            setSortFunc(() => sortByEmployeeSurnameAsc);
        }
    }

    function onClickSortByEmployeeEmail(e) {
        if (sortBy === "sortByEmployeeEmailAsc") {
            setSortBy("sortByEmployeeEmailDesc");
            setSortFunc(() => sortByEmployeeEmailDesc);
        }
        else {
            setSortBy("sortByEmployeeEmailAsc");
            setSortFunc(() => sortByEmployeeEmailAsc);
        }
    }

    function onClickSortByScore(e) {
        if (sortBy === "sortByScoreAsc") {
            setSortBy("sortByScoreDesc");
            setSortFunc(() => sortByScoreDesc);
        }
        else {
            setSortBy("sortByScoreAsc");
            setSortFunc(() => sortByScoreAsc);
        }
    }

    function getArrowIconForDateHeader() {
        if (sortBy === "sortByDateDesc") {
            return <ArrowUp />
        }
        else if (sortBy === "sortByDateAsc") {
            return <ArrowDown />
        }
        return null;
    }
    function getArrowIconForEmployeeIdHeader() {
        if (sortBy === "sortByEmployeeIdDesc") {
            return <ArrowUp />
        }
        else if (sortBy === "sortByEmployeeIdAsc") {
            return <ArrowDown />
        }
        return null;
    }
    function getArrowIconForEmployeeNameHeader() {
        if (sortBy === "sortByEmployeeNameDesc") {
            return <ArrowUp />
        }
        else if (sortBy === "sortByEmployeeNameAsc") {
            return <ArrowDown />
        }
        return null;
    }
    function getArrowIconForEmployeeSurnameHeader() {
        if (sortBy === "sortByEmployeeSurnameDesc") {
            return <ArrowUp />
        }
        else if (sortBy === "sortByEmployeeSurnameAsc") {
            return <ArrowDown />
        }
        return null;
    }
    function getArrowIconForEmployeeEmailHeader () {
        if (sortBy === "sortByEmployeeEmailDesc") {
            return <ArrowUp />
        }
        else if (sortBy === "sortByEmployeeEmailAsc") {
            return <ArrowDown />
        }
        return null;
    }
    function getArrowIconForScoreHeader () {
        if (sortBy === "sortByScoreDesc") {
            return <ArrowUp />
        }
        else if (sortBy === "sortByScoreAsc") {
            return <ArrowDown />
        }
        return null;
    }

    return (
        <div>
            {
                loading ?
                    <div>loading...</div>
                :
                    <div>
                        <div  className='mb-3' style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center' }}>
                            <Button variant='outline-primary' size='sm' onClick={(e) => load()}>Reload</Button>
                        </div>
                        <Table>
                            <thead>
                                <tr style={{ borderBottom: '1px solid black', borderTop: '1px solid black' }}>
                                    <td>{getArrowIconForDateHeader()}&nbsp;<span className='sortable-table-header' onClick={onClickSortByDate}>วันที่</span></td>
                                    <td>{getArrowIconForEmployeeIdHeader()}&nbsp;<span className='sortable-table-header' onClick={onClickSortByEmployeeId}>รหัสพนักงาน</span></td>
                                    <td>{getArrowIconForEmployeeNameHeader()}&nbsp;<span className='sortable-table-header' onClick={onClickSortByEmployeeName}>ชื่อ</span></td>
                                    <td>{getArrowIconForEmployeeSurnameHeader()}&nbsp;<span className='sortable-table-header' onClick={onClickSortByEmployeeSurname}>นามสกุล</span></td>
                                    <td>{getArrowIconForEmployeeEmailHeader()}&nbsp;<span className='sortable-table-header' onClick={onClickSortByEmployeeEmail}>อีเมล์</span></td>
                                    <td>{getArrowIconForScoreHeader()}&nbsp;<span className='sortable-table-header' onClick={onClickSortByScore}>คะแนน</span></td>
                                </tr>
                            </thead>
                            <tbody>
                            {
                                answerDocs ?
                                    answerDocs.sort((elem1, elem2) => sortFunc(elem1, elem2)).map((data, i) => {
                                        return (
                                            <tr key={`${data.employeeId}_answer_${i}`}>
                                                <td style={{ fontFamily: 'courier new', fontSize: '14px' }}>{formatDate(data)}</td>
                                                <td>{data.employeeId}</td>
                                                <td>{data.name}</td>
                                                <td>{data.surname}</td>
                                                <td>{data.email}</td>
                                                <td>{data.score} / {data.answers.length}</td>
                                            </tr>
                                        );
                                    })
                                :
                                    <tr><td colSpan={5}>No data</td></tr>
                            }
                            </tbody>
                        </Table>
                    </div>

            }
        </div>
    );
}

export default AdminUsersAnswersAll;
